var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformDarkGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13728_131002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 18.3327C5.3988 18.3327 1.66797 14.6018 1.66797 9.99935C1.66797 5.39685 5.3988 1.66602 10.0013 1.66602C14.6038 1.66602 18.3346 5.39685 18.3346 9.99935C18.3346 14.6018 14.6038 18.3327 10.0013 18.3327ZM10.0013 16.666C11.7694 16.666 13.4651 15.9636 14.7153 14.7134C15.9656 13.4632 16.668 11.7675 16.668 9.99935C16.668 8.23124 15.9656 6.53555 14.7153 5.2853C13.4651 4.03506 11.7694 3.33268 10.0013 3.33268C8.23319 3.33268 6.5375 4.03506 5.28726 5.2853C4.03701 6.53555 3.33464 8.23124 3.33464 9.99935C3.33464 11.7675 4.03701 13.4632 5.28726 14.7134C6.5375 15.9636 8.23319 16.666 10.0013 16.666ZM9.16797 5.83268H10.8346V7.49935H9.16797V5.83268ZM9.16797 9.16602H10.8346V14.166H9.16797V9.16602Z",
    fill: "#204A22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13728_131002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformDarkGreenIcon);
export default __webpack_public_path__ + "static/media/inform-dark-green-icon.3a9971c98d88fc30bd30f8a8ec5c0b16.svg";
export { ForwardRef as ReactComponent };